import React from 'react';
import { Typography, Chip, Box } from '@mui/material';
import dayjs from 'dayjs';
import { CircularStaticProgressUI } from '../Interface';

const baseStyle = {
  caption: {
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
};

const Fields = ({ data }) => {
  return (
    <div className="mt-3">
      <div>
        <Typography>{data.s_projectName}</Typography>
      </div>
      <div>
        <Typography
          sx={{
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
          }}
        >
          {data.s_projectOrderNumber}
        </Typography>
      </div>
      <div className="mt-0.5">
        {data.operations?.map((operation) => {
          const color = operation.plannedTime > operation.timeSpentSoFar ? 'black' : 'red';

          return (
            <Box
              key={operation.st_id}
              display="flex"
              alignItems="center"
              backgroundColor={operation.st_statusColor}
              mb={0.5}
              px={0.5}
              borderRadius={2}
              border="2px solid #8e8e8e"
              position="relative"
              justifyContent="space-between"
            >
              <Typography
                sx={{ fontSize: '0.8rem' }}
              >{`${operation.operationName} ${operation.resourceoneName ? `- ${operation.resourceoneName}` : ''}`}</Typography>

              <Box mt={0.2}>
                <Typography sx={{ fontSize: '0.8rem', color: color, fontWeight: 'bold' }}>
                  {`${operation.timeSpentSoFar}/${operation.plannedTime}`}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </div>
      <div>
        <Typography>{dayjs(data.dueDate).format('YYYY-MM-DD')}</Typography>
      </div>
      <div>
        <Typography>{data.s_total_plannedtime} óra</Typography>
      </div>
    </div>
  );
};

export default Fields;
